module.exports = __webpack_public_path__ + "img/43.8149f270.jpg";